<template>
  <div class="checkout">
    <div class="container">
      <div class="row pb-4">
        <div class="col-lg-12">
          <LoadedComponent :loading="loading" :percentual="percentual" />
          <!-- End .checkout-title -->
          <div class="card mt-4" v-if="loading == false">
            <div class="card-header text-dark">Nuova presentazione</div>
            <form class="pt-4 pr-4 pl-4" @submit.prevent="new_presentation">
              <div class="row">
                <div class="col-sm-6">
                  <label for="nome_presentazione">Titolo *</label>
                  <input type="text" class="form-control" name="nome" id="nome_presentazione"
                    placeholder="Scrivi il titolo della presentazione " v-model="form.name" required />
                  <div class="alert alert-danger" v-if="errors.name">
                    {{ errors.name[0] }}
                  </div>
                </div>
                <div class="col-md-6">
                  <label for="autore">Autore *</label>
                  <input type="text" class="form-control" v-model="form.author" name="autore" id="autore"
                    placeholder="Scrivi l' autore" required />
                  <div class="alert alert-danger" v-if="errors.author">
                    {{ errors.author[0] }}
                  </div>
                </div>
                <!-- End .col-sm-6 -->


                <div class="col-md-12">
                  <label for="distretto_anatomico" class="form-label">Distretto Anatomico</label>
                  <select class="form-control" id="distretto_anatomico" name="id_distretto"
                    v-model="form.anatomical_district_id">
                    <option value="0" disabled selected>
                      Seleziona il distretto anatomico
                    </option>
                    <option v-for="anatomical in anatomicalDistrict" :key="anatomical.id" :value="anatomical.id">
                      {{ anatomical.name }}
                    </option>
                  </select>
                  <div class="alert alert-danger" v-if="errors.anatomical_district_id">
                    {{ errors.anatomical_district_id[0] }}
                  </div>
                </div>

                <div class="col-sm-12">
                  <h5 class="card-title text-center mb-1">Trattamenti</h5>
                  <p class="mb-2 text-center">Seleziona i trattamenti</p>
                  <div class="row">
                    <div v-for="patology in patologies" :key="patology.id" class="col-md-2">
                      <!-- Categoria con icona per aprire/chiudere -->
                      <div class="mb-1">
                        <input type="checkbox" v-model="form.patologies" :value="patology.id" />
                        {{ patology.name }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-12">
                  <label for="descrizione">Descrizione </label>
                  <textarea class="form-control" id="descrizione" rows="3" v-model="form.description" name="descrizione"
                    placeholder="Descrizione dell'articolo"></textarea>

                  <div class="alert alert-danger" v-if="errors.description">
                    {{ errors.description[0] }}
                  </div>
                </div>

                <h6 class="text-center">Caricamento allegati</h6>
                <div class="input-group mb-3">
                  <div class="custom-file">
                    <input type="file" class="custom-file-input" name="files[]" ref="fileInput"
                      @change="handleFileUpload" id="fileInput" aria-describedby="inputGroupFileAddon01" multiple />
                    <label class="custom-file-label text-center" for="fileInput" id="labelsfiles">{{ nameFiles
                      }}</label>
                  </div>
                </div>
              </div>
              <!-- End .row -->

              <div class="row flex-column pb-2 pl-2 pr-2">
                <div class="flex-row">
                  <button type="submit" class="btn btn-primary float-right">
                    Pubblica la presentazione<i class="las la-save"></i>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- End .container -->
  </div>
</template>
<script>
import httpauth from "@/services/httpauth.js";
import httpservices from "@/services/httpservices.js";
import router from "@/router";
import { useAuth } from "@/stores/auth.js";
import LoadedComponent from "@/components/LoadedComponent.vue";
export default {
  name: "CreatePresentation",
  components: { LoadedComponent }, //
  props: {},
  data() {
    return {
      libraries: [],
      permission: {},
      patologies: [],
      categoryMedical: [],
      attachments: [],
      loading: true,
      nameFiles: "Scegli i file (MAX 1 GIGA)",
      anatomicalDistrict: [],
      percentual: 0,
      form: {
        name: "",
        author: "",
        patologies: [],
        subpatologies: [],
        anatomical_district_id: 0,
        description: "",
      },
      errors: [],
    };
  },
  mounted() { },
  created() {

    this.fetchPatology();
    this.fetchAtomicalDistrict();
  },
  methods: {
    async fetchPatology() {
      await httpservices
        .getPatology()
        .then((response) => {
          this.patologies = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async fetchAtomicalDistrict() {
      await httpservices
        .getAnatomicalDistrict()
        .then((response) => {
          this.anatomicalDistrict = response.data.data;
          this.loading = false;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async new_presentation() {
      this.loading = true;
      this.percentual = 0;
      await httpauth
        .post("/presentations", this.form)
        .then((response) => {
          if (response.data.status)
          {
            localStorage.setItem(
              "successMessagePresentation",
              response.data.message
            );
            if (this.attachments.length > 0)
            {
              this.uploadFiles(response.data.data.id);
            } else
            {
              router.push("/presentation");
            }
          }
        })
        .catch((error) => {
          if (error.response.data.errors)
          {
            this.errors = error.response.data.errors;
          }
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
          console.log(error);
        });
    },
    async uploadFiles(id) {
      await httpservices
        .uploadAttachments(
          this.attachments,
          id,
          "activity",
          0,
          (percentCompleted) => {
            this.percentual = percentCompleted;
            // Puoi fare qualcosa con il valore percentCompleted qui
          }
        )
        .then(() => {
          this.loading = false;
          this.nameFiles = "Scegli i file (MAX 1 GIGA)";
          router.push("/presentation");
        })
        .catch((error) => {
          if (error.response.data.errors)
          {
            this.errors = error.response.data.errors;
          }
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
          console.log(error);
        });
    },
    handleFileUpload(event) {
      const maxSize = 1 * 1024 * 1024 * 1024;
      const files = Array.from(event.target.files);
      const totalSize = files.reduce(
        (accumulator, file) => accumulator + file.size,
        0
      );
      const validFiles = [];
      if (totalSize <= maxSize)
      {
        const allowedTypes = [
          "application/pdf",
          "application/msword",
          "application/vnd.ms-office",
          "video/mp4",
          "image/jpeg",
          "image/png",
          "image/jpg",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ];
        Array.from(files).forEach((file) => {
          // Esegui l'azione desiderata su ogni file
          if (
            !allowedTypes.includes(file.type) ||
            !httpservices.checkDicom(file)
          )
          {
            alert(
              "Per favore seleziona un file valido (PDF/DOC/DOCX/JPEG/JPG/PNG/MP4/DCM)."
            );
            this;
            return;
          }
          validFiles.push(file.name);
        });

        this.attachments = files;
        this.nameFiles = validFiles.join(", ");
      } else
      {
        alert("La dimensione totale dei file supera 1 GB");
      }
    },
  },
};
</script>